import { useRouterState } from '@tanstack/react-router';
import { useSistemaQuery } from '@/features/sistema/api';
import styles from './RouterProgress.module.css';

export function RouterProgress() {
    const { sistema } = useSistemaQuery();

    const isLoading = useRouterState({
        select: (s) => s.status === 'pending',
    });

    const color = sistema?.layout.sic_cor_primaria ?? '#28BDF8';

    return (
        <div
            aria-hidden='true'
            className={styles.progress}
            data-loading={isLoading}
            style={{ color }}
        >
            <div className={styles.bar} />
        </div>
    );
}
